import styled from "styled-components"
import { getCssSizeValue, isStringEmpty } from "@/utils/utils"
import { motion } from "framer-motion"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Video from "@/components/common/Video"
import React, { useState } from "react"
import VideoControls from "@/components/Banners/SubPage/Components/VideoControls"
import GridContainer from "@/components/common/GridContainer"
import BannerCard from "@/components/Banners/SubPage/Components/BannerCard"

const Wrapper = styled.section`
	overflow: hidden;
	position: relative;
	height: 100svh;
	width: 100%;
	display: flex;
	align-items: flex-end;
	padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-bottom: ${getCssSizeValue(48)};
	}
`

const StyledAssetWrapper = styled(motion.div)`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	width: 100%;
	height: 100%;

	figure {
		height: 100%;
	}
`

const CommonVideo = styled(Video)`
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
`

const StyledGridContainer = styled(GridContainer)`
	position: relative;
	z-index: 1;
	align-items: end;
	pointer-events: none;
`

export default function VideoWithButtonToPlay({ data }) {
	const assetVideoUrl = data?.video?.url || ""
	const externalVideoUrl = data?.externalVideo?.url || ""
	const videoSrc = assetVideoUrl !== "" ? assetVideoUrl : externalVideoUrl

	const [isVideoPlaying, setIsPlaying] = useState(false)

	const handleToggleVideo = () => {
		setIsPlaying((prev) => !prev)
	}

	return (
		<Wrapper>
			{!isStringEmpty(videoSrc) && <VideoControls handleToggleVideo={handleToggleVideo} isVideoPlaying={isVideoPlaying} />}
			<StyledAssetWrapper>
				<CommonVideo src={videoSrc} playing={isVideoPlaying} resetOnPause={false} onClick={handleToggleVideo} />
			</StyledAssetWrapper>

			<StyledGridContainer>
				<BannerCard data={data} />
			</StyledGridContainer>
		</Wrapper>
	)
}
